var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import cx from 'classnames';
import { ELSCheckBox, ELSIcon } from 'components/common';
import { KEY_CODES } from 'constants/app.constant';
import { getIndexByKeyCode, onKeyDownHandler } from 'helpers/ui.helper';
import React, { Component } from 'react';
var initialOptionIdx = -1;
var checkAllKey = 'CHECK_ALL_KEY';
var DEFAULT_ALL_OPTION_DISPLAY_TILE = 'All';
var instanceCounter = 0;
var CheckboxMenu = /** @class */ (function (_super) {
    __extends(CheckboxMenu, _super);
    function CheckboxMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.displayLabelRef = React.createRef();
        _this.allOptionDisplayTitle = DEFAULT_ALL_OPTION_DISPLAY_TILE;
        _this.listboxId = "checkbox-menu-listbox-".concat((instanceCounter += 1));
        _this.checkOptionAllForTempCheckKey = function () {
            var _a;
            var tempCheckedKeys = (_a = _this.props.checkedKeys) !== null && _a !== void 0 ? _a : [];
            if (tempCheckedKeys.length === _this.safeOptions.length) {
                return __spreadArray([checkAllKey], tempCheckedKeys, true);
            }
            return tempCheckedKeys;
        };
        _this.changeOptionListPosition = function () {
            var optionBoxBoundingClientRect = _this.displayLabelRef.current.getBoundingClientRect();
            if (optionBoxBoundingClientRect.x > window.innerWidth / 2) {
                _this.setState({ shouldChangeOptionListPosition: true });
            }
            else {
                _this.setState({ shouldChangeOptionListPosition: false });
            }
        };
        _this.changeDisplayLabel = function () {
            _this.setState({ displayLabel: _this.props.customLabelRender() });
        };
        _this.getCheckedKeysWhenClickNotAllOption = function (checkedKeys, option) {
            var _a, _b;
            var newChecked;
            var optionKey = option.key;
            var excludeOption = (_b = (_a = _this.props.dependentOption) === null || _a === void 0 ? void 0 : _a.find(function (o) { return o.parentOption === optionKey; })) === null || _b === void 0 ? void 0 : _b.dependentOptionlist;
            if (checkedKeys.includes(optionKey)) {
                newChecked = checkedKeys.filter(function (key) { return key !== optionKey && !(excludeOption === null || excludeOption === void 0 ? void 0 : excludeOption.includes(key)); });
            }
            else {
                newChecked = __spreadArray(__spreadArray([], checkedKeys, true), [optionKey], false).concat(excludeOption).filter(function (o) { return o; });
            }
            return _this.getCheckedKeysIntegrateWithCheckAllCondition(newChecked);
        };
        _this.getCheckedKeysIntegrateWithCheckAllCondition = function (checkedKeys) {
            if (checkedKeys.includes(checkAllKey) && checkedKeys.length <= _this.safeOptions.length) {
                return checkedKeys.filter(function (key) { return key !== checkAllKey; });
            }
            if (checkedKeys.length === _this.safeOptions.length) {
                return __spreadArray([checkAllKey], checkedKeys, true);
            }
            return checkedKeys;
        };
        _this.getCheckedKeysWhenClickAllOption = function (checkedKeys) {
            if (checkedKeys.includes(checkAllKey)) {
                return [];
            }
            return __spreadArray([checkAllKey], _this.safeOptions.map(function (opt) { return opt.key; }), true);
        };
        _this.getDisplayLabel = function (checkedKeys) {
            if (_this.props.customLabelRender) {
                return _this.props.customLabelRender();
            }
            if (checkedKeys.includes(checkAllKey) || (!checkedKeys.length && _this.props.customMultiSelectedLabel)) {
                return _this.allOptionDisplayTitle;
            }
            if (_this.props.customMultiSelectedLabel && checkedKeys.length > 1) {
                return _this.props.customMultiSelectedLabel;
            }
            var selectedOptions = _this.safeOptions.filter(function (option) { return checkedKeys.includes(option.key); });
            return selectedOptions.map(function (option) { return option.name; }).join(', ');
        };
        _this.handleOptionChange = function (option) {
            if (option.key === checkAllKey) {
                _this.setState(function (prevState) { return ({
                    tempCheckedKeys: _this.getCheckedKeysWhenClickAllOption(prevState.tempCheckedKeys)
                }); });
                return;
            }
            _this.setState(function (prevState) { return ({
                tempCheckedKeys: _this.getCheckedKeysWhenClickNotAllOption(prevState.tempCheckedKeys, option)
            }); });
        };
        _this.handleMenuBlur = function () {
            // Only update if menu is still open (not already closed by TAB handler)
            if (_this.state.opened) {
                _this.updateData();
                _this.hideOptions();
            }
        };
        _this.handleMenuClick = function () {
            _this.toggleOptions();
            _this.updateData();
        };
        _this.hideOptions = function () {
            _this.setState({
                opened: false,
                optionIdxSelectedByKey: initialOptionIdx
            });
        };
        // SPACE: Choose option
        // ENTER: Apply the option
        _this.handleMenuKeyDown = function (evt) {
            var _a;
            var key = evt.keyCode;
            var isShiftTab = evt.shiftKey;
            if (key === KEY_CODES.TAB) {
                // Only intercept TAB when the menu is open — let native TAB work when closed
                // so focus-trap and browser handle order correctly in all contexts
                if (!_this.state.opened)
                    return;
                var menuRoot_1 = _this.displayLabelRef.current;
                var root = ((_a = menuRoot_1 === null || menuRoot_1 === void 0 ? void 0 : menuRoot_1.closest('[role="dialog"]')) !== null && _a !== void 0 ? _a : document.body);
                // Exclude the open option list's own checkboxes — they unmount when the menu closes
                var focusableElements_1 = Array.from(root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')).filter(function (el) { return el.offsetParent !== null && (el === menuRoot_1 || !menuRoot_1.contains(el)); });
                var currentIndex = focusableElements_1.indexOf(menuRoot_1);
                var targetIndex_1 = isShiftTab ? currentIndex - 1 : currentIndex + 1;
                if (currentIndex !== -1 && isShiftTab && targetIndex_1 < 0) {
                    // No element before the trigger within the dialog — let native Shift+Tab exit backward
                    _this.updateData();
                    _this.hideOptions();
                    return;
                }
                evt.preventDefault();
                _this.updateData();
                _this.hideOptions();
                setTimeout(function () {
                    var _a, _b;
                    (_b = ((_a = focusableElements_1[targetIndex_1]) !== null && _a !== void 0 ? _a : _this.displayLabelRef.current)) === null || _b === void 0 ? void 0 : _b.focus();
                }, 0);
                return;
            }
            // Prevent default for other keys
            evt.preventDefault();
            var max = _this.safeOptions.length;
            switch (key) {
                case KEY_CODES.ENTER: {
                    if (_this.state.opened) {
                        _this.updateData();
                        _this.hideOptions();
                    }
                    else {
                        _this.openOptionByKeyboard();
                    }
                    break;
                }
                case KEY_CODES.SPACE: {
                    if (_this.state.opened) {
                        var selectedIdx = _this.state.optionIdxSelectedByKey;
                        if (selectedIdx !== initialOptionIdx) {
                            _this.handleOptionChange(_this.allOptions[selectedIdx]);
                        }
                    }
                    else {
                        _this.openOptionByKeyboard();
                    }
                    break;
                }
                case KEY_CODES.UP:
                case KEY_CODES.DOWN: {
                    _this.setState(function (prevState) { return ({
                        optionIdxSelectedByKey: getIndexByKeyCode(key, prevState.optionIdxSelectedByKey, max)
                    }); });
                    break;
                }
                case KEY_CODES.ESC: {
                    _this.hideOptions();
                    _this.setState({
                        tempCheckedKeys: _this.checkOptionAllForTempCheckKey()
                    });
                    break;
                }
                default: {
                    break;
                }
            }
        };
        _this.toggleOptions = function () {
            _this.setState(function (prevState) { return ({
                opened: !prevState.opened,
                optionIdxSelectedByKey: initialOptionIdx
            }); });
        };
        _this.openOptionByKeyboard = function () {
            _this.setState({
                opened: true,
                optionIdxSelectedByKey: 0
            });
        };
        _this.updateData = function () {
            var tempCheckedKeys = _this.state.tempCheckedKeys;
            var checkedKeys;
            if (tempCheckedKeys.length) {
                checkedKeys = tempCheckedKeys.filter(function (key) { return key !== checkAllKey; });
            }
            else {
                checkedKeys = _this.safeOptions.map(function (option) { return option.key; });
                _this.setState({ tempCheckedKeys: __spreadArray(__spreadArray([], checkedKeys, true), [checkAllKey], false) });
            }
            _this.props.onOptionChange(checkedKeys);
            _this.setState(function (prevState) { return ({ displayLabel: _this.getDisplayLabel(prevState.tempCheckedKeys) }); });
        };
        _this.isDependentOptionHidden = function (excludeOptions, key) {
            var _a;
            var isHide = excludeOptions === null || excludeOptions === void 0 ? void 0 : excludeOptions.includes(key);
            var dependentOption = (_a = _this.props.dependentOption) === null || _a === void 0 ? void 0 : _a.find(function (option) { return option.dependentOptionlist.includes(key); });
            var hasParentDependentOption = _this.allOptions.findIndex(function (option) { return option.key === (dependentOption === null || dependentOption === void 0 ? void 0 : dependentOption.parentOption); }) > -1;
            return isHide && hasParentDependentOption;
        };
        var tempCheckedKeys = _this.checkOptionAllForTempCheckKey();
        _this.allOptionDisplayTitle = props.allOptionDisplayTitle || DEFAULT_ALL_OPTION_DISPLAY_TILE;
        _this.state = {
            opened: false,
            optionIdxSelectedByKey: initialOptionIdx,
            shouldChangeOptionListPosition: false,
            tempCheckedKeys: tempCheckedKeys,
            displayLabel: _this.getDisplayLabel(tempCheckedKeys)
        };
        _this.allOptions = __spreadArray([{ key: checkAllKey, name: 'Select All' }], _this.safeOptions, true);
        return _this;
    }
    CheckboxMenu.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.changeOptionListPosition);
    };
    CheckboxMenu.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.allOptions = __spreadArray([{ key: checkAllKey, name: 'Select All' }], this.safeOptions, true);
        if (this.state.opened && prevState.opened !== this.state.opened) {
            this.changeOptionListPosition();
        }
        if (this.props.customLabelRender && this.props.customLabelRender() !== this.state.displayLabel) {
            this.changeDisplayLabel();
        }
        if (prevProps.checkedKeys !== this.props.checkedKeys) {
            var tempCheckedKeys = this.checkOptionAllForTempCheckKey();
            this.setState({
                tempCheckedKeys: tempCheckedKeys,
                displayLabel: this.getDisplayLabel(tempCheckedKeys)
            });
        }
    };
    CheckboxMenu.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.changeOptionListPosition);
    };
    Object.defineProperty(CheckboxMenu.prototype, "safeOptions", {
        get: function () {
            var _a;
            return (_a = this.props.options) !== null && _a !== void 0 ? _a : [];
        },
        enumerable: false,
        configurable: true
    });
    CheckboxMenu.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.state, displayLabel = _b.displayLabel, opened = _b.opened, shouldChangeOptionListPosition = _b.shouldChangeOptionListPosition, optionIdxSelectedByKey = _b.optionIdxSelectedByKey, tempCheckedKeys = _b.tempCheckedKeys;
        var _c = this.props, inline = _c.inline, dependentOption = _c.dependentOption, customDisplayValue = _c.customDisplayValue, ariaLabelledBy = _c["aria-labelledby"], ariaLabel = _c["aria-label"];
        var excludeOptions = dependentOption === null || dependentOption === void 0 ? void 0 : dependentOption.flatMap(function (o) { return o.dependentOptionlist; });
        var activeDescendant = opened && optionIdxSelectedByKey !== initialOptionIdx ? "checkbox-menu-option-".concat((_a = this.allOptions[optionIdxSelectedByKey]) === null || _a === void 0 ? void 0 : _a.key) : undefined;
        return (<div role="combobox" tabIndex={0} ref={this.displayLabelRef} aria-expanded={opened} aria-haspopup="listbox" aria-controls={opened ? this.listboxId : undefined} aria-activedescendant={activeDescendant} aria-labelledby={ariaLabelledBy} aria-label={ariaLabelledBy ? undefined : ariaLabel} onBlur={this.handleMenuBlur} onClick={this.handleMenuClick} onKeyDown={this.handleMenuKeyDown} className={cx({ 'u-els-display-inline-block': inline }, 'c-select-menu c-checkbox-menu')}>
        {customDisplayValue || (<div className={cx({ 'u-els-display-inline-block': inline, 'c-select-menu--opened': opened }, 'c-select-menu__trigger')}>
            <span title={displayLabel} className="c-select-menu__display-label">
              {displayLabel}
            </span>
            <ELSIcon name="chevron-down" size="1x" customClass="u-els-margin-left-1o2 c-select-menu__rotate-arrow"/>
          </div>)}
        {opened && (<div className={cx('c-select-menu__options', { 'c-select-menu__options--position-changed': shouldChangeOptionListPosition })}>
            <div className="c-select-menu__options-wrapper">
              <ul id={this.listboxId} role="listbox" aria-multiselectable="true" className="c-select-menu__options-list">
                {this.allOptions.map(function (option, idx) {
                    var changeHandler = function (evt) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        _this.handleOptionChange(option);
                    };
                    var name = option.name, key = option.key;
                    return (<li role="option" id={"checkbox-menu-option-".concat(key)} aria-selected={tempCheckedKeys.includes(key)} title={name} key={key} className={cx('c-select-menu__option', {
                            'c-select-menu__option--selected-by-key': optionIdxSelectedByKey === idx,
                            'c-select-menu__option--select-all': key === checkAllKey,
                            'c-select-menu__option--hide': _this.isDependentOptionHidden(excludeOptions, key)
                        })} onClick={changeHandler} onKeyDown={function (evt) { return onKeyDownHandler(evt, changeHandler); }}>
                      <ELSCheckBox id={key} name={name} value={key} checked={tempCheckedKeys.includes(key)}>
                        {name}
                      </ELSCheckBox>
                    </li>);
                })}
              </ul>
            </div>
          </div>)}
      </div>);
    };
    return CheckboxMenu;
}(Component));
export default CheckboxMenu;
